import React from "react"
import { render } from "react-dom"
import { Provider } from "react-redux"
import { Router } from "react-router"
import I18n from "redux-i18n"
import FastClick from "fastclick"
import { split, trimStart } from "lodash"

import config from "core/config"
import history from "core/history"
import configureStore from "data/configureStore"
import { startRavenJS } from "shared/services/analytics"
import { createUrlForSeveralParcels } from "shared/utils"

import App from "views/App"

startRavenJS()

// -------------------- added for backward compatibility with previously used urls -------------------- //
// backward compatibility for single parcel url: http://tracking.webinterpret.com/parcel?WI1614p09
if (window.location.pathname === "/parcel") {
  const parcel = trimStart(window.location.search, "?")
  const url = `${window.location.origin}${window.location.pathname}/${parcel}`

  window.location.replace(url)

// backward compatibility for multiple parcels url: http://tracking.webinterpret.com/parcels?WI1571p0,WI1608p0,WI1614p0
} else if (window.location.pathname === "/parcels" && window.location.search.indexOf(",") !== -1) {
  let parcels = trimStart(window.location.search, "?")
  parcels = split(parcels, ",")
  parcels = createUrlForSeveralParcels(parcels)

  const url = `${window.location.origin}${parcels}`

  window.location.replace(url)
// -------------------- end of backward compatibility code -------------------- //
} else {
  const store = configureStore({
    i18nState: {
      lang: "en",
      translations: {},
    },
  })

  // Make taps on links and buttons work fast on mobiles
  FastClick.attach(document.body)

  const root = document.getElementById("app")

  const renderClient = () => {
    render(
      <Provider store={store}>
        <I18n translations={{}} fallbackLang="en" useReducer>
          <Router history={history}>
            <App />
          </Router>
        </I18n>
      </Provider>, root)
  }

  // Render the client-side DOM
  renderClient()

  // Enable Hot Module Replacement (HMR)
  if (config.env !== "production" && module.hot) {
    module.hot.accept("./views/App", () => {
      renderClient()
    })
  }
}



// WEBPACK FOOTER //
// ./src/index.js